import { constants } from 'modules/common';

import { isValidQBOVendorName } from '../../../selectors/qbooks';

const { qBooksConstants } = constants;

export const checkIsDisplayNameInvalid = (name: string | undefined) => {
    if (!name) {
        return true;
    }

    if (!isValidQBOVendorName(name)) {
        return true;
    }

    const isDisplayNameEmpty = !name.trim();
    const isDisplayNameLengthExceeded = name.length > qBooksConstants.DISPLAY_NAME_MAX_LENGTH;
    const isDisplayNameHasEmoji = /\p{Extended_Pictographic}/u.test(name);

    if (isDisplayNameEmpty || isDisplayNameLengthExceeded || isDisplayNameHasEmoji) {
        return true;
    }

    return false;
};
